const Accessibility = Object.freeze({
  REQUIRED: 'REQUIRED',
  OPTIONAL: 'OPTIONAL',
  NOT_REQUIRED: 'NOT_REQUIRED'
})

export default Accessibility
